/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'
import 'vuetify/dist/vuetify.min.css'

// Plugins
import { registerPlugins } from '@/plugins'
import axios from 'axios'
// import VueSweetalert2 from 'sweetalert2'
import Noty from 'noty'
import 'noty/lib/noty.css'
import 'noty/lib/themes/mint.css'
import '@/assets/css/style.css'
import { Notification } from '@/helper/Notification'
import VendorHelper from '@/helper/helper.js';
import VueStickyDirective from 'vue-sticky-directive'
import User from '@/helper/User.js';
import router from '@/router/index';
import { toggleConsoleOutput } from "@/helper/utils.js"
window.User = User;
// window.VendorHelper = VendorHelper;
(window as any).VendorHelper = VendorHelper;
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

toggleConsoleOutput(process.env.NODE_ENV !== 'production');

// Global error handler for stale cached assets after new deployments
// This catches errors when old cached JS/CSS bundles no longer exist on server
window.addEventListener('error', (event) => {
  const errorMsg = event.message || '';
  const errorTarget = event.target as HTMLElement;

  // Check for chunk loading errors (old cached bundles missing)
  if (
    errorMsg.includes('ChunkLoadError') ||
    errorMsg.includes('Loading chunk') ||
    errorMsg.includes('Loading CSS chunk') ||
    errorMsg.includes('Failed to fetch dynamically imported module') ||
    (errorTarget && (errorTarget.tagName === 'SCRIPT' || errorTarget.tagName === 'LINK'))
  ) {
    console.log('🔄 Stale cached assets detected. Clearing cache and reloading...');
    handleStaleAssetError();
  }
}, true);

// Handle unhandled promise rejections (like network errors for missing chunks)
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  if (
    reason && (
      reason.name === 'ChunkLoadError' ||
      (reason.message && (
        reason.message.includes('Failed to fetch dynamically imported module') ||
        reason.message.includes('Loading chunk') ||
        reason.message.includes('ERR_NETWORK')
      ))
    )
  ) {
    console.log('🔄 Network/chunk error detected. Clearing cache and reloading...');
    handleStaleAssetError();
  }
});

// Function to clear all caches and reload
function handleStaleAssetError() {
  // Prevent multiple reloads
  if (sessionStorage.getItem('_staleAssetReload')) {
    sessionStorage.removeItem('_staleAssetReload');
    return; // Already tried once, don't loop
  }
  sessionStorage.setItem('_staleAssetReload', 'true');

  // Clear localStorage
  localStorage.clear();

  // Clear service worker caches
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => caches.delete(name));
    });
  }

  // Unregister service workers
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(reg => reg.unregister());
    });
  }

  // Hard reload with cache busting
  const url = new URL(window.location.href);
  url.searchParams.set('_refresh', String(Date.now()));
  window.location.href = url.toString();
}

declare global {
  interface Window {
    Toast: any;
    Noty: any;
    Notification: any;
    User: any;
  }
}

window.Noty = Noty;
window.Notification = Notification;



// import AppStorage  from '@/helper/AppStorage.js';
// window.AppStorage =AppStorage;

const app = createApp(App)



registerPlugins(app);
// app.config.globalProperties.$swal = VueSweetalert2;
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$noty = Noty


// window.Toast = VueSweetalert2.mixin({
//     toast: true,
//     position: "top-end",
//     showConfirmButton: false,
//     timer: 3000,
//     timerProgressBar: true,
//     didOpen: (toast) => {
//         toast.addEventListener("mouseenter", VueSweetalert2.stopTimer);
//         toast.addEventListener("mouseleave", VueSweetalert2.resumeTimer);
//     },
// });
app.use(pinia);
app.use(VueStickyDirective);
app.mount('#app')
